{
  "version": 1,
  "asset_id": "0c300141-3e2c-49dd-948d-f8c45ebe5a6c",
  "project_id": "949ac23c-9e33-4376-b191-e19499cf4fa3",
  "url": "/__l5e/assets-v1/0c300141-3e2c-49dd-948d-f8c45ebe5a6c/bahcesehir-hizli-elektrikci-7-24-dukkan-1.jpg",
  "r2_key": "a/v1/949ac23c-9e33-4376-b191-e19499cf4fa3/0c300141-3e2c-49dd-948d-f8c45ebe5a6c/bahcesehir-hizli-elektrikci-7-24-dukkan-1.jpg",
  "original_filename": "bahcesehir-hizli-elektrikci-7-24-dukkan-1.jpg",
  "size": 499318,
  "content_type": "image/jpeg",
  "created_at": "2026-09-11T16:18:35Z"
}
